import { render, staticRenderFns } from "./favorite-products-heading.vue?vue&type=template&id=6483f3df&scoped=true&"
import script from "./favorite-products-heading.ts?vue&type=script&lang=ts&"
export * from "./favorite-products-heading.ts?vue&type=script&lang=ts&"
import style0 from "./favorite-products-heading.scss?vue&type=style&index=0&id=6483f3df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6483f3df",
  null
  
)

export default component.exports